import { useLocation } from "@reach/router";
import { useTranslation } from "gatsby-plugin-react-i18next";
import Filter from "../../components/Filter";
import Button from "../../components/general/Button";
import GridItem from "../../components/general/GridItem";
import { getUrlFromStoryblokLink } from "../../utils/storyblok/urls";

const FilterModule = ({ links }: Queries.FilterModuleFragment) => {
	const { t } = useTranslation();

	const location = useLocation();
	return (
		<GridItem>
			<Filter filterOnLabel={t("Filter")}>
				{links?.map((link) => {
					const url = link && getUrlFromStoryblokLink(link.link);
					const trailingSlash = /\/$/;
					const isActive = url === location.pathname.replace(trailingSlash, "");
					return (
						link?.label &&
						url && (
							<Button
								key={link.label}
								label={link.label}
								href={url}
								variant={isActive ? "secondary" : "noBg"}
							/>
						)
					);
				})}
			</Filter>
		</GridItem>
	);
};

export default FilterModule;
